"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _theme = require("./theme");

var _polished = require("polished");

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LoaderWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  & svg {\n    animation-play-state: running;\n    animation-delay: 0s;\n    height: ", "px;\n    width: ", "px;\n    background: none;\n    align-self: center;\n    & .defs {\n      animation-play-state: running;\n      animation-delay: 0s;\n    }\n  }\n  ", "\n  ", "\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.fullscreen && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100vw;\n      height: 100vh;\n      z-index: 3000;\n      background-color: ", ";\n      display: grid;\n      place-content: center;\n    "])), function (props) {
    return (0, _polished.transparentize)(1 - props.opacity, props.overlay);
  });
}, function (props) {
  return props.section && (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      position: relative;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      display: grid;\n      place-content: center;\n    "])));
});

var defaultColors = [_theme.FlexTheme.PrimaryColor, _theme.FlexTheme.PrimaryRed, _theme.FlexTheme.PrimaryYellow, _theme.FlexTheme.PrimaryGreen, _theme.FlexTheme.PrimaryColor_dark_10, _theme.FlexTheme.PrimaryColor_light_10];

var Loader = function Loader(props) {
  var colors = [].concat(_toConsumableArray(props.colors), defaultColors);

  var newprops = _objectSpread({}, props);

  var duration = newprops.duration;

  if (newprops.mini) {
    newprops.size = newprops.size != 80 ? newprops.size : 22;
    newprops.color = newprops.color ? newprops.color : _theme.FlexTheme.PrimaryColor;
  }

  if (newprops.grey) {
    colors = [_theme.FlexTheme.PrimaryGrey, (0, _polished.darken)(0.1, _theme.FlexTheme.PrimaryGrey), (0, _polished.lighten)(0.05, _theme.FlexTheme.PrimaryGrey), (0, _polished.lighten)(0.1, _theme.FlexTheme.PrimaryGrey), (0, _polished.lighten)(0.15, _theme.FlexTheme.PrimaryGrey), (0, _polished.lighten)(0.2, _theme.FlexTheme.PrimaryGrey)];
  }

  if (newprops.color) {
    colors = [newprops.color, (0, _polished.darken)(0.1, newprops.color), (0, _polished.lighten)(0.05, newprops.color), (0, _polished.lighten)(0.1, newprops.color), (0, _polished.lighten)(0.15, newprops.color), (0, _polished.lighten)(0.2, newprops.color)];
  }

  if (newprops.speed) {
    switch (newprops.speed) {
      case "fast":
        duration = 0.6;
        break;

      case "slow":
        duration = 2;
        break;

      default:
        duration = 1;
    }
  }

  return /*#__PURE__*/_react["default"].createElement(LoaderWrapper, newprops, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "80px",
    height: "80px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/_react["default"].createElement("defs", {
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("filter", {
    id: "gooey",
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    colorInterpolationFilters: "sRGB",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    stdDeviation: "4",
    className: "defs"
  }), /*#__PURE__*/_react["default"].createElement("feComponentTransfer", {
    result: "cutoff",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("feFuncA", {
    type: "linear",
    slope: "10",
    intercept: "-5",
    className: "defs"
  })))), /*#__PURE__*/_react["default"].createElement("g", {
    filter: "url(#gooey)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(50 50)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(258)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "0",
    r: "10.5333",
    fill: colors[0],
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "6;14;6",
    dur: "".concat(4 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(4 * duration, "s"),
    className: "defs"
  })), /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "".concat(4 * duration, "s"),
    repeatCount: "indefinite",
    begin: "0s",
    className: "defs"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(50 50)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(276)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "0",
    r: "7.6",
    fill: colors[1],
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "6;14;6",
    dur: "".concat(2 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(3.3 * duration, "s"),
    className: "defs"
  })), /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "".concat(2 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(0.6 * duration, "s"),
    className: "defs"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(50 50)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(54)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "0",
    r: "8.4",
    fill: colors[2],
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "6;14;6",
    dur: "".concat(1.3 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(2.6 * duration, "s"),
    className: "defs"
  })), /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "".concat(1.3 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(1.3 * duration, "s"),
    className: "defs"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(50 50)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(312)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "0",
    r: "8.13333",
    fill: colors[3],
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "6;14;6",
    dur: "".concat(1 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(2 * duration, "s"),
    className: "defs"
  })), /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "".concat(1 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(2 * duration, "s"),
    className: "defs"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(50 50)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(330)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "0",
    r: "10",
    fill: colors[4],
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "6;14;6",
    dur: "".concat(0.8 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(1.3 * duration, "s"),
    className: "defs"
  })), /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "".concat(0.8 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(2.6 * duration, "s"),
    className: "defs"
  }))), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(50 50)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(108)",
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "25",
    cy: "0",
    r: "10.8",
    fill: colors[5],
    className: "defs"
  }, /*#__PURE__*/_react["default"].createElement("animate", {
    attributeName: "r",
    keyTimes: "0;0.5;1",
    values: "6;14;6",
    dur: "".concat(0.6 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(0.6 * duration, "s"),
    className: "defs"
  })), /*#__PURE__*/_react["default"].createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    keyTimes: "0;1",
    values: "0;360",
    dur: "".concat(0.6 * duration, "s"),
    repeatCount: "indefinite",
    begin: "-".concat(3.3 * duration, "s"),
    className: "defs"
  }))))));
};

exports.Loader = Loader;
Loader.defaultProps = {
  colors: [],
  overlay: "white",
  opacity: 0.8,
  duration: 1,
  size: 80
};
Loader.propTypes = {
  colors: _propTypes["default"].array,
  color: _propTypes["default"].string,
  grey: _propTypes["default"].bool,
  overlay: _propTypes["default"].string,
  opacity: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  speed: _propTypes["default"].string,
  size: _propTypes["default"].number,
  section: _propTypes["default"].bool,
  fullscreen: _propTypes["default"].bool,
  mini: _propTypes["default"].bool
};